function getUnit(input) {
  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function toUnitless(length) {
  return parseFloat(length);
}
export {
  getUnit,
  toUnitless
};
//# sourceMappingURL=cssUtils.es.js.map
